document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.cases-swiper', {
    slidesPerView: 1,
    spaceBetween: 40,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});

document.addEventListener("DOMContentLoaded", () => {

    const titles = document.querySelectorAll(".hero-title");
    const images = document.querySelectorAll(".hero-image");

    let current = 0;
    const total = titles.length;
    const interval = 3500;

    function updateSlides(index) {
      titles.forEach((t, i) => {
        t.classList.remove("is-active", "is-exit");
        if (i === index) t.classList.add("is-active");
      });

      images.forEach((img, i) => {
        img.classList.remove("is-active", "is-prev", "is-next");

        if (i === index) img.classList.add("is-active");
        else if (i === (index - 1 + total) % total) img.classList.add("is-prev");
        else if (i === (index + 1) % total) img.classList.add("is-next");
      });
    }

    updateSlides(current);

    setInterval(() => {
      titles[current].classList.add("is-exit");
      current = (current + 1) % total;
      updateSlides(current);
    }, interval);

  });

  document.addEventListener('DOMContentLoaded', () => {
    const drawerToggle = document.getElementById('drawer-toggle');
    const body = document.body;
    let lastScrollY = 0;

    if (drawerToggle) {
      drawerToggle.addEventListener('change', () => {
        if (drawerToggle.checked) {
          lastScrollY = window.scrollY || window.pageYOffset;
          body.style.top = `-${lastScrollY}px`;
          body.classList.add('menu-open');
        } else {
          body.classList.remove('menu-open');
          body.style.top = '';
          window.scrollTo(0, lastScrollY);
        }
      });
      
    }
  });

  document.addEventListener("DOMContentLoaded", () => {

  const basePath = document.body.dataset.theme; 

  const formatsData = {
    tv: {
      title: "TV",
      text: "A televisão é o meio mais poderoso para alcançar e converter os catarinenses em consumidores. Na NSC TV, você pode anunciar em breaks comerciais, patrocinar programas de alta audiência, como Jornal do Almoço e Globo Esporte, ou ainda criar programetes personalizados. São diversos formatos de anúncio que atendem os mais diferentes objetivos de negócio.",
      image: `${basePath}/assets/images/banners/tv.webp`
    },
    radio: {
      title: "Rádio",
      text: "As rádios da NSC ajudam sua marca a estar sempre presente no dia a dia das pessoas e a criar conexão com o público. Na Atlântida, CBN e Itapema, você pode optar por spots comerciais, merchandising com comunicadores, textos ao vivo, patrocínios de programas, ações nas redes sociais dos comunicadores, e até realizar promoções ou eventos direto no seu ponto de venda.",
      image: `${basePath}/assets/images/banners/radio.webp`
    },
    digital: {
      title: "Digital",
      text: "A NSC oferece um ecossistema digital completo, com soluções de mídia nos maiores portais de conteúdo de Santa Catarina — NSC Total, G1 SC, GE SC — e nas redes sociais das rádios Atlântida, CBN e Itapema, unindo alcance, segmentação e engajamento em todas as fases da jornada do consumidor.",
      image: `${basePath}/assets/images/banners/digital.webp`
    },
    dooh: {
      title: "DOOH",
      text: "A NSC também leva sua marca para a rua com painéis de LED modernos instalados em locais movimentados das principais cidades de Santa Catarina. Diferente dos outdoors tradicionais, o DOOH (Digital Out of Home) é uma forma moderna e chamativa de divulgar campanhas e estar presente no dia a dia de milhares de pessoas.",
      image: `${basePath}/assets/images/banners/dooh.webp`
    }
  };

  Object.values(formatsData).forEach(item => {
    const img = new Image();
    img.src = item.image;
  });

  const tabs = document.querySelectorAll(".formats-tab");
  const title = document.getElementById("formatsTitle");
  const text = document.getElementById("formatsText");
  const media = document.querySelector("#formatsMedia img");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const format = tab.dataset.format;
      title.textContent = formatsData[format].title;
      text.textContent = formatsData[format].text;
      media.src = formatsData[format].image;

      media.style.opacity = 0;
      setTimeout(() => {
        media.src = formatsData[format].image;
        media.style.opacity = 1;
      }, 150);
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  

  document.querySelectorAll('.content-tab').forEach(tab => {
    tab.addEventListener('click', () => {

      document
        .querySelectorAll('.content-tab')
        .forEach(t => t.classList.remove('active'));

      document
        .querySelectorAll('.content-area')
        .forEach(a => a.classList.remove('active'));

      tab.classList.add('active');
      document
        .getElementById(`content-${tab.dataset.target}`)
        .classList.add('active');
    });
  });

});

document.addEventListener("DOMContentLoaded", () => {
  const select = document.getElementById('select-praca');
  const grupos = document.querySelectorAll('.praca-group');

  function mostrarPraca(id) {
    grupos.forEach(group => group.style.display = 'none');
    const alvo = document.getElementById(id);
    if (alvo) alvo.style.display = 'grid';
  }

  select.addEventListener('change', () => {
    if (select.value) {
      mostrarPraca(select.value);
    }
  });

  if (select.options.length > 1) {
    select.selectedIndex = 1;
    mostrarPraca(select.value);
  }
});

  document.addEventListener('DOMContentLoaded', () => {
  const submenuToggles = document.querySelectorAll('.submenu-toggle');
  const megaMenus = document.querySelectorAll('.mega');
  const nav = document.querySelector('.navbar');

  submenuToggles.forEach(toggle => {
    toggle.addEventListener('change', () => {
      if (toggle.checked) {
        submenuToggles.forEach(other => {
          if (other !== toggle) {
            other.checked = false;
          }
        });
      }
    });
  });

  document.addEventListener('click', (e) => {
    const clickedInsideMega = e.target.closest('.mega');
    const clickedOnToggle = e.target.closest('.nav-item.has-submenu');

    if (!clickedInsideMega && !clickedOnToggle) {
      submenuToggles.forEach(toggle => {
        toggle.checked = false;
      });
    }
  });
});